import { Skeleton, Typography } from '@customink/pigment-react';
import {
  type ProjectItem,
  useProduct,
} from '@customink/project-service-react-components';
import useMediaQuery from '@mui/material/useMediaQuery';

type ProjectItemProductNameProps = {
  item: ProjectItem;
};

export const ProjectItemProductName = ({
  item,
}: ProjectItemProductNameProps) => {
  const { data: product } = useProduct({
    colorId: item.product?.colorId,
  });

  const isNarrowScreen = useMediaQuery('(max-width: 450px)');

  return (
    <Typography
      display="block"
      fontSize={isNarrowScreen ? '14.4px' : '16px'}
      lineHeight="1.25"
      weight="bold"
    >
      {product?.name || <Skeleton width="80px" />}
    </Typography>
  );
};
